import { render, staticRenderFns } from "./page.vue?vue&type=template&id=2ec808e4"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"
import style0 from "./page.vue?vue&type=style&index=0&id=2ec808e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports